import { initAvatar, getModel } from './avatar.js';
import { setModel as setLipSyncModel } from './lip-sync.js';
import { setModel as setExpressionModel } from './expression-manager.js';
import { connect, sendModelLoaded, sendError } from './ws-client.js';
import { executeCommand, getAvailableCommands } from './chat-control.js';

const AVATAR_SERVER_PORT = parseInt(
  new URLSearchParams(window.location.search).get('port') || '3000',
  10,
);

function addChatMessage(text: string, type: 'system' | 'user' | 'error' = 'system'): void {
  const log = document.getElementById('chat-log');
  if (!log) return;
  const div = document.createElement('div');
  div.className = `msg ${type}`;
  div.textContent = text;
  log.appendChild(div);
  log.scrollTop = log.scrollHeight;
}

function initChat(): void {
  const input = document.getElementById('chat-input') as HTMLInputElement;
  const sendBtn = document.getElementById('chat-send');

  if (!input || !sendBtn) return;

  function handleSend(): void {
    const text = input.value.trim();
    if (!text) return;

    addChatMessage(`> ${text}`, 'user');
    input.value = '';

    if (text.toLowerCase() === 'help') {
      addChatMessage('Available commands:');
      for (const cmd of getAvailableCommands()) {
        addChatMessage(`  ${cmd}`);
      }
      return;
    }

    const result = executeCommand(text);
    if (result) {
      addChatMessage(`Playing: ${result}`);
    } else {
      addChatMessage(`Unknown command: "${text}". Type "help" for a list.`, 'error');
    }
  }

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') handleSend();
  });
  sendBtn.addEventListener('click', handleSend);

  document.querySelectorAll('#quick-commands button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const cmd = (btn as HTMLElement).dataset.cmd;
      if (!cmd) return;
      addChatMessage(`> ${cmd}`, 'user');
      const result = executeCommand(cmd);
      if (result) {
        addChatMessage(`Playing: ${result}`);
      }
    });
  });

  addChatMessage('Avatar control ready. Type "help" for commands.');
}

async function main(): Promise<void> {
  const container = document.getElementById('container');
  if (!container) {
    console.error('Missing #container element');
    return;
  }

  try {
    await initAvatar(container);

    const model = getModel();
    if (model) {
      setLipSyncModel(model);
      setExpressionModel(model);
      connect(AVATAR_SERVER_PORT);
      sendModelLoaded('Hiyori');
    }

    initChat();
  } catch (err) {
    console.error('Failed to initialize avatar:', err);
    connect(AVATAR_SERVER_PORT);
    sendError(err instanceof Error ? err.message : String(err));
  }
}

main();
